import { useAtomValue } from 'jotai';
import { UserMarketing } from '~/app/compositions/content/service-footer/components/user-marketing';
import { FooterCarline } from '~/app/compositions/content/service-footer/components/user-marketing/footer-carline';
import { ServiceFooterStyle } from '~/app/compositions/content/service-footer/service-footer-style';
import { CarConfiUiConfiguration } from '~/app/market-config';
import { useBreakPoint } from '~/hooks/responsive/useBreakPoint';
import { state } from '~/storage';
import { Container, InnerContainer } from '~/styles/container';
import { DefaultBar } from '~/styles/default-bar';
import { DATA_TEST_ID } from '~/test/data-test-id';

interface props {
	marketUi: CarConfiUiConfiguration | undefined;
}

export function ServiceFooter({ marketUi }: props) {
	const isBodyNoneScroll = useAtomValue(state.isBodyNoneScroll);
	const { isLBreakpoint } = useBreakPoint();

	if (!marketUi) return <></>;

	return (
		<ServiceFooterStyle
			data-testid={DATA_TEST_ID.FOOTER_CONTAINER}
			id="service-footer"
			isBodyNoneScroll={isBodyNoneScroll}>
			<Container>
				<InnerContainer>
					<DefaultBar className="footer-container" $isScrolled={true}>
						<div className="footer-container__inner-container">
							{!isLBreakpoint && <FooterCarline />}
							<div className="info-block">
								{marketUi.calculationInfoComponent}
								<UserMarketing className="marketing" />
							</div>
						</div>
					</DefaultBar>
				</InnerContainer>
			</Container>
		</ServiceFooterStyle>
	);
}
